document.addEventListener("DOMContentLoaded", function () {
  const leftMenuItems = document.querySelectorAll(".left-menu li");
  const sublists = document.querySelectorAll(".right-menu .sublist");

  leftMenuItems.forEach((item) => {
    item.addEventListener("mouseover", function () {
      const sublistId = this.getAttribute("data-sublist");
      sublists.forEach((sublist) => {
        sublist.classList.remove("active");
        if (sublist.id === sublistId) {
          sublist.classList.add("active");
        }
      });
    });
  });
});

// Pardot Success-error check

document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("cm-form");
  const successMessage = document.getElementById("cm-success-message");
  const errorMessage = document.getElementById("cm-error-message");

  // Function to show success or error messages based on URL fragment
  function showMessage() {
    const urlHash = window.location.hash;

    if (urlHash === "#success") {
      // Select the modal with ID cmModal2
      var modal = document.querySelector("#cmModal2");

      if (modal) {
        // Display the modal
        modal.style.display = "block";
      } else {
        console.warn("Modal not found for selector: #cmModal2");
      }
    } else if (urlHash === "#error") {
      // errorMessage.style.display = "block";
      // Select the modal with ID cmModal3
      var modal = document.querySelector("#cmModal3");

      if (modal) {
        // Display the modal
        modal.style.display = "block";
      } else {
        console.warn("Modal not found for selector: #cmModal3");
      }
    }
  }

  // Hide previous messages on form submit
  form.addEventListener("submit", function (event) {
    successMessage.style.display = "none";
    errorMessage.style.display = "none";
  });

  // Show message based on URL fragment on page load
  showMessage();
});
// testing end

// pardt form popup/modal begin
// Get all links with an href attribute that points to a modal
document.querySelectorAll('a[href^="#cmModal"]').forEach(function (link) {
  // Get the modal target from the href attribute
  var modalSelector = link.getAttribute("href");
  var modal = document.querySelector(modalSelector);

  // When the user clicks on the link, open the modal
  link.onclick = function (event) {
    event.preventDefault(); // Prevent the default action
    if (modal) {
      console.log("Opening modal:", modalSelector); // Debugging line

      // Get all elements with class 'cmModal3'
      var modalsError = document.getElementsByClassName("cmModal3");

      // Loop through the collection and hide each error modal
      for (var i = 0; i < modalsError.length; i++) {
        modalsError[i].style.display = "none";
      }

      // Display the target modal
      modal.style.display = "block";
    } else {
      console.warn("Modal not found for selector:", modalSelector); // Debugging line
    }
  };
});

// Get the close button and attach the close functionality
document.querySelectorAll(".cmClose").forEach(function (span) {
  span.onclick = function () {
    var modal = span.closest(".cmModal");
    modal.style.display = "none";
  };
});
document.querySelectorAll(".cmClose2").forEach(function (span) {
  span.onclick = function () {
    var modal = span.closest(".cmModal2");
    modal.style.display = "none";
  };
});
document.querySelectorAll(".cmClose3").forEach(function (span) {
  span.onclick = function () {
    var modal = span.closest(".cmModal3");
    modal.style.display = "none";
  };
});

// When the user clicks anywhere outside of the modal, close it
window.onclick = function (event) {
  var modals = document.querySelectorAll(".cmModal");
  modals.forEach(function (modal) {
    if (event.target == modal) {
      // console.log('Click outside modal, closing:', modal); // Debugging line
      modal.style.display = "none";
    }
  });
};
window.onclick = function (event) {
  var modals = document.querySelectorAll(".cmModal2");
  modals.forEach(function (modal) {
    if (event.target == modal) {
      // console.log('Click outside modal, closing:', modal); // Debugging line
      modal.style.display = "none";
    }
  });
};
window.onclick = function (event) {
  var modals = document.querySelectorAll(".cmModal3");
  modals.forEach(function (modal) {
    if (event.target == modal) {
      // console.log('Click outside modal, closing:', modal); // Debugging line
      modal.style.display = "none";
    }
  });
};

// Hide/unhide webinar form
document.addEventListener("DOMContentLoaded", function () {
  // Get all <a> tags on the page
  var links = document.querySelectorAll("a");

  // Iterate through each <a> tag
  links.forEach(function (link) {
    // Check if the href attribute of the <a> tag matches '#webinar-form'
    if (link.getAttribute("href") === "#webinar-form") {
      var hiddenDivv = document.getElementById(
        "shopify-section-template--27106503885140__17297700797542ebde"
      );
      hiddenDivv.style.display = "none";
      // Add an event listener for a click event on this link
      link.addEventListener("click", function (event) {
        event.preventDefault(); // Prevent default anchor behavior

        // Unhide the div with the specified ID
        var hiddenDiv = document.getElementById(
          "shopify-section-template--27106503885140__17297700797542ebde"
        );
        if (hiddenDiv) {
          hiddenDiv.style.display = "block"; // Change this to 'flex' or whatever is needed
        }
      });
    }
  });
});

// custom video hide controls
document.addEventListener("DOMContentLoaded", function () {
  const videoElement = document.querySelectorAll(".video-background");
  videoElement.forEach((video) => {
    video.removeAttribute("controls"); // Ensures that the controls attribute is removed
  });
});

// custom-grid-collection-bu-section transition effect
document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(
    ".custom-grid-collection-bu-section"
  );
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        }
      });
    },
    { threshold: 0.1 }
  );

  sections.forEach((section) => observer.observe(section));
});

// enable-disable contact form submit btn
document.addEventListener("DOMContentLoaded", () => {
  const submitButton = document.querySelector(".cm-btn");
  const agreeTerms = document.getElementById("agreeTerms");

  if (submitButton && agreeTerms) {
    // Disable the button on page load
    submitButton.disabled = true;

    // Add event listener to checkbox
    agreeTerms.addEventListener("click", () => {
      submitButton.disabled = !agreeTerms.checked;
    });
  }
});

// contact form product dowpdown validate
function validateProductDropdown(selectElement) {
  const allowedValues = [
    "RFID (Automotive)",
    "RFID (non-Automotive)",
    "Power Magnetics (Automotive)",
    "Power Magnetics (non-Automotive)",
    "VR",
    "Filters",
  ];

  const selectedValue = selectElement.value;
  if (!allowedValues.includes(selectedValue) && selectedValue !== "") {
    alert("Invalid selection. Please choose a valid option.");
    selectElement.value = ""; // Reset to the placeholder
  }
}

// contact form textarea validation for malware
// Full contact form validation + cross-browser malware/Cyrillic sanitization
// document.addEventListener("DOMContentLoaded", function () {
//   const textarea = document.getElementsByName("inquiries")[0];
//   const errorSpan = document.getElementById("inquiries-error");
//   const form = document.getElementById("cm-form"); // your form ID

//   if (!textarea) return;

//   // ---------- Sanitizer ----------
//   function sanitizeInput() {
//     let text = textarea.value;

//     // --- 1. Check for Cyrillic ---
//     if (/[\u0400-\u04FF]/.test(text)) {
//       textarea.value = "";
//       if (errorSpan) errorSpan.textContent = "Cyrillic characters are not allowed.";
//       return; // EARLY EXIT
//     } else if (errorSpan) {
//       errorSpan.textContent = "";
//     }

//     // --- 2. Sanitize HTML/JS/PHP/URLs ---
//     const unsafePatterns = [
//       /<\/?[^>]+/g, 					// HTML tags (even incomplete)
//       /(?:javascript|vbscript|data):/gi,
//       /on\w+\s*=\s*['"]?[^'" >]+/gi,
//       /document\.\w+/gi,
//       /window\.\w+/gi,
//       /alert\s*\([^)]*\)/gi,
//       /eval\s*\([^)]*\)/gi,
//       /<\?(php)?[\s\S]*?\?>/gi, 		// PHP
//       /https?:\/\/\S+/gi, 			// URLs
//       /href\s*=\s*(['"])[\s\S]*?\1/gi,
//       /href\s*=\s*[^\s>]+/gi
//     ];
//     unsafePatterns.forEach(pattern => text = text.replace(pattern, ""));

//     // Cleanup extra spaces/newlines
//     textarea.value = text.replace(/\s{2,}/g, " ").replace(/\n{3,}/g, "\n\n");
//   }

//   // ---------- Event-based sanitization (Standard) ----------
//   textarea.addEventListener("input", sanitizeInput);
//   textarea.addEventListener("beforeinput", () => setTimeout(sanitizeInput, 0));
//   textarea.addEventListener("keyup", sanitizeInput);

//   textarea.addEventListener("paste", function (e) {
//     e.preventDefault();
//     let pastedText = (e.clipboardData || window.clipboardData).getData("text");
//     textarea.setRangeText(pastedText, textarea.selectionStart, textarea.selectionEnd, "end");
//     // Ensure sanitization runs after the paste replacement
//     setTimeout(sanitizeInput, 0); 
//   });

//   ["change", "blur"].forEach(evt => textarea.addEventListener(evt, sanitizeInput));

//   // -----------------------------------------------------------
//   // ---------- Browser-specific handling (The Fix) ----------
//   // -----------------------------------------------------------
//   const isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

//   if (!isFirefox) {
//     // Chrome + Edge: override .value to catch DevTools changes (Kept as requested)
//     try {
//       const descriptor = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value");
//       if (descriptor && descriptor.configurable) {
//         Object.defineProperty(textarea, "value", {
//           get: function () { return descriptor.get.call(this); },
//           set: function (val) {
//             descriptor.set.call(this, val);
//             sanitizeInput();
//           }
//         });
//       }
//     } catch (e) { /* ignore */ }
//   } else {
//     // 🔥 FIX FOR FIREFOX (Alternative): Aggressive event listening at the document level
//     // This attempts to catch synthetic/DevTools 'input' events missed by the textarea's listener.
    
//     // We add an 'input' listener to the document in the CAPTURING phase.
//     document.addEventListener('input', function(e) {
//         // Only run if the target is our specific textarea
//         if (e.target === textarea) {
//             sanitizeInput();
//         }
//     }, true); // The 'true' enables the capturing phase
    
//     // As a final, nuclear option for DevTools persistence, reintroduce 1ms polling
//     // but only on Firefox, as this is the only remaining way to force a check.
//     setInterval(sanitizeInput, 1); 
//   }

//   // -----------------------------------------------------------
//   // ---------- Form validation (CRITICAL Safeguard) ----------
//   // -----------------------------------------------------------
//   if (form) {
//     form.addEventListener("submit", function (event) {
//       // CRITICAL: Final sanitization right before form submission 
//       // This is the absolute last chance to clear invalid content, 
//       // ensuring that even if DevTools input briefly persists, it's cleaned on submit.
//       sanitizeInput(); 
      
//       let isValid = true;

//       function validateField(field, errorId, message) {
//         // ... (validation logic unchanged) ...
//         if (!field || !field.value || !field.value.trim()) {
//           const el = document.getElementById(errorId);
//           if (el) el.innerHTML = message;
//           if (isValid && field) { field.focus(); isValid = false; }
//         } else {
//           const el = document.getElementById(errorId);
//           if (el) el.innerHTML = "";
//         }
//       }

//       // ... (all validation calls) ...
//       validateField(document.getElementsByName("company")[0], "company-error", "Company field is required.");
//       validateField(document.getElementsByName("telephone")[0], "telephone-error", "Telephone field is required.");
//       validateField(document.getElementsByName("name")[0], "name-error", "Name field is required.");
//       validateField(document.getElementsByName("email")[0], "email-error", "Email field is required.");
//       validateField(document.getElementsByName("country")[0], "country-error", "Country field is required.");
//       validateField(document.getElementsByName("product")[0], "product-error", "Product field is required.");
//       validateField(document.getElementsByName("sector")[0], "sector-error", "Sector field is required.");
//       validateField(document.getElementsByName("application")[0], "application-error", "Application field is required.");
//       validateField(document.getElementsByName("city")[0], "city-error", "City field is required.");
//       validateField(document.getElementsByName("inquiries")[0], "inquiries-error", "Inquiries field is required.");

//       if (!isValid) {
//         event.preventDefault();
//       }
//     });
//   }

//   // Run once on load to clear any pre-existing invalid content
//   sanitizeInput();
// });

document.addEventListener("DOMContentLoaded", function () {
  const textarea = document.getElementsByName("inquiries")[0];
  const errorSpan = document.getElementById("inquiries-error");
  const form = document.getElementById("cm-form"); // your form ID
  const form2 = document.getElementById("cm-form2"); // your form ID

  if (!textarea) return;
  
  // Keep track of last sanitized value to minimize DOM writes when not needed
  let lastSanitized = null;

  // ---------- Sanitizer ----------
  function sanitizeInput() {
    // Always read the current live value (important for DevTools changes)
    const originalText = String(textarea.value || "");

    // --- 1. Check for Cyrillic (Cyrillic Unicode block \u0400-\u04FF and extended \u0500-\u052F) ---
    // include both ranges to be thorough
    if (/[\u0400-\u04FF\u0500-\u052F]/.test(originalText)) {
      // When Cyrillic detected, clear and report error
      textarea.value = "";
      lastSanitized = "";
      if (errorSpan) {
        errorSpan.textContent = "Cyrillic characters are not allowed.";
        errorSpan.style.color = "red";
      }
      return; // early exit
    } else if (errorSpan) {
      // clear any previous Cyrillic error (but do not remove other validation errors)
      if (errorSpan.textContent === "Cyrillic characters are not allowed.") {
        errorSpan.textContent = "";
      }
    }

    // --- 2. Sanitize HTML/JS/PHP/URLs and suspicious attributes/javascript pseudo-protocols ---
    const unsafePatterns = [
      /<\/?[^>]+>/g,                        // HTML tags (more strict - matches <...>)
      /(?:javascript|vbscript|data):/gi,    // JS-like protocols
      /on\w+\s*=\s*(['"`])[\s\S]*?\1/gi,   // inline event handler attributes with quotes
      /on\w+\s*=\s*[^\s>]+/gi,              // inline event handler attributes without quotes
      /document\.\w+/gi,
      /window\.\w+/gi,
      /alert\s*\([^)]*\)/gi,
      /eval\s*\([^)]*\)/gi,
      /<\?(php)?[\s\S]*?\?>/gi,             // PHP tags
      /https?:\/\/\S+/gi,                   // URLs (http/https)
      /href\s*=\s*(['"`])[\s\S]*?\1/gi,
      /href\s*=\s*[^\s>]+/gi,
      /src\s*=\s*(['"`])[\s\S]*?\1/gi,
      /src\s*=\s*[^\s>]+/gi
    ];

    let sanitizedText = originalText;
    unsafePatterns.forEach(pattern => {
      sanitizedText = sanitizedText.replace(pattern, "");
    });

    // Collapse excessive spaces/newlines
    sanitizedText = sanitizedText.replace(/[ \t]{2,}/g, " ").replace(/\n{3,}/g, "\n\n");

    // Always overwrite the textarea value with sanitized result to prevent DevTools persistence
    // BUT avoid unnecessary writes if identical to last sanitized to reduce repaint thrash
    if (lastSanitized !== sanitizedText) {
      textarea.value = sanitizedText;
      lastSanitized = sanitizedText;
    }
  }

  // ---------- Event-based sanitization ----------
  textarea.addEventListener("input", sanitizeInput);
  textarea.addEventListener("beforeinput", () => setTimeout(sanitizeInput, 0));
  textarea.addEventListener("keyup", sanitizeInput);

  textarea.addEventListener("paste", function (e) {
    // sanitize pasted text
    e.preventDefault();
    let pastedText = (e.clipboardData || window.clipboardData).getData("text");
    // Insert pasted text at selection and then sanitize (setRangeText keeps undo stack nicer)
    try {
      textarea.setRangeText(pastedText, textarea.selectionStart, textarea.selectionEnd, "end");
    } catch (err) {
      // fallback if setRangeText isn't supported
      const start = textarea.selectionStart || 0;
      const end = textarea.selectionEnd || 0;
      const val = textarea.value;
      textarea.value = val.slice(0, start) + pastedText + val.slice(end);
    }
    setTimeout(sanitizeInput, 0);
  });

  ["change", "blur"].forEach(evt => textarea.addEventListener(evt, sanitizeInput));

  // -----------------------------------------------------------
  // ---------- Browser-specific handling / DevTools fallback
  // -----------------------------------------------------------

  const ua = navigator.userAgent || "";
  const isFirefox = ua.toLowerCase().indexOf("firefox") > -1;

  // Try to override property descriptor for modern browsers (Chrome/Edge) to catch programmatic sets
  try {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value");
    if (descriptor && descriptor.configurable) {
      Object.defineProperty(textarea, "value", {
        get: function () { return descriptor.get.call(this); },
        set: function (val) {
          descriptor.set.call(this, val);
          // small async to avoid interfering with other code paths that set value then manipulate selection
          setTimeout(sanitizeInput, 0);
        }
      });
    }
  } catch (err) {
    // ignore if descriptor not accessible
  }

  if (isFirefox) {
    // Firefox: input mutations from DevTools can bypass listeners and property overrides.
    // Use multiple layers: capturing input listener, MutationObserver (best-effort), and polling.
    document.addEventListener('input', function (e) {
      if (e.target === textarea) sanitizeInput();
    }, true); // capturing

    // MutationObserver to detect attribute changes (e.g., setAttribute) or child changes
    // Note: value property changes (element.value = ...) do NOT fire mutations, but some devtools use setAttribute
    try {
      const mo = new MutationObserver(mutations => {
        for (const m of mutations) {
          if (m.type === "attributes" && m.target === textarea && (m.attributeName === "value" || m.attributeName === "placeholder")) {
            sanitizeInput();
            return;
          }
          if (m.type === "characterData" || m.type === "childList") {
            // unlikely on textarea but keep as fallback
            sanitizeInput();
            return;
          }
        }
      });
      mo.observe(textarea, { attributes: true, childList: true, characterData: true, subtree: true });
    } catch (err) {
      // ignore if MutationObserver not allowed
    }

    // Polling: Firefox "nuclear" option. Use a short interval but not 1ms to avoid CPU spike.
    // 40ms gives good responsiveness while being reasonable for CPU. If you truly need 1ms, change it.
    const POLL_INTERVAL_MS = 40;
    setInterval(sanitizeInput, POLL_INTERVAL_MS);

    // Optional: simple DevTools detection (heuristic) - only warns in console & sets a subtle visual flag
    try {
      let devtoolsOpen = false;
      const threshold = 160;
      setInterval(function () {
        const widthDiff = window.outerWidth - window.innerWidth > threshold;
        const heightDiff = window.outerHeight - window.innerHeight > threshold;
        if (widthDiff || heightDiff) {
          if (!devtoolsOpen) {
            devtoolsOpen = true;
            // subtle visual cue: border color
            textarea.style.boxShadow = "0 0 0 2px rgba(255,165,0,0.15)";
            console.warn("DevTools may be open — client-side input tampering is discouraged.");
          }
        } else {
          if (devtoolsOpen) {
            devtoolsOpen = false;
            textarea.style.boxShadow = "";
          }
        }
      }, 1000);
    } catch (err) {
      // ignore
    }
  }

  // Additional fallback: listen for focus/blur & periodically sanitize while focused (covers some edge cases)
  let focusInterval = null;
  textarea.addEventListener("focus", function () {
    sanitizeInput();
    focusInterval = setInterval(sanitizeInput, 200);
  });
  textarea.addEventListener("blur", function () {
    sanitizeInput();
    if (focusInterval) {
      clearInterval(focusInterval);
      focusInterval = null;
    }
  });

  // -----------------------------------------------------------
  // ---------- Form validation (CRITICAL Safeguard)
  // -----------------------------------------------------------
  if (form) {
    form.addEventListener("submit", function (event) {
      // Final sanitization right before submission
      sanitizeInput();
      let isValid = true;

      function validateField(field, errorId, message) {
        if (!field || !field.value || !field.value.trim()) {
          const el = document.getElementById(errorId);
          if (el) el.innerHTML = message;
          if (isValid && field) { field.focus(); isValid = false; }
        } else {
          const el = document.getElementById(errorId);
          if (el) el.innerHTML = "";
        }
      }

      // Run validation checks (kept as in your original code)
      validateField(document.getElementsByName("company")[0], "company-error", "Company field is required.");
      validateField(document.getElementsByName("telephone")[0], "telephone-error", "Telephone field is required.");
      validateField(document.getElementsByName("name")[0], "name-error", "Name field is required.");
      validateField(document.getElementsByName("email")[0], "email-error", "Email field is required.");
      validateField(document.getElementsByName("country")[0], "country-error", "Country field is required.");
      validateField(document.getElementsByName("product")[0], "product-error", "Product field is required.");
      validateField(document.getElementsByName("sector")[0], "sector-error", "Sector field is required.");
      validateField(document.getElementsByName("application")[0], "application-error", "Application field is required.");
      validateField(document.getElementsByName("city")[0], "city-error", "City field is required.");
      validateField(document.getElementsByName("inquiries")[0], "inquiries-error", "Inquiries field is required.");

      if (!isValid) {
        event.preventDefault();
      }
    });
  }
  if (form2) {
    form2.addEventListener("submit", function (event) {
      // Final sanitization right before submission
      sanitizeInput();
      let isValid = true;

      function validateField(field, errorId, message) {
        if (!field || !field.value || !field.value.trim()) {
          const el = document.getElementById(errorId);
          if (el) el.innerHTML = message;
          if (isValid && field) { field.focus(); isValid = false; }
        } else {
          const el = document.getElementById(errorId);
          if (el) el.innerHTML = "";
        }
      }

      // Run validation checks (kept as in your original code)
      validateField(document.getElementsByName("company")[0], "company-error", "Company field is required.");
      validateField(document.getElementsByName("telephone")[0], "telephone-error", "Telephone field is required.");
      validateField(document.getElementsByName("name")[0], "name-error", "Name field is required.");
      validateField(document.getElementsByName("email")[0], "email-error", "Email field is required.");
      validateField(document.getElementsByName("country")[0], "country-error", "Country field is required.");
      validateField(document.getElementsByName("city")[0], "city-error", "City field is required.");
      validateField(document.getElementsByName("inquiries")[0], "inquiries-error", "Inquiries field is required.");

      if (!isValid) {
        event.preventDefault();
      }
    });
  }

  // Run once on load to clear any pre-existing invalid content
  sanitizeInput();
});


// sites redirect to respective div
document.addEventListener("DOMContentLoaded", function () {
  const OFFSET = 190; // Adjust based on your sticky header height
  const hash = window.location.hash;

  if (hash) {
    const id = hash.substring(1);

    const scrollToTarget = () => {
      const target = document.getElementById(id);

      if (target) {
        const scrollTop =
          target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
        window.scrollTo({
          top: scrollTop,
          behavior: "smooth",
        });
        return true;
      }
      return false;
    };

    // Retry scrolling until the element exists or timeout (e.g. max 2 seconds)
    let attempts = 0;
    const maxAttempts = 20; // ~2 seconds (20 × 100ms)
    const interval = setInterval(() => {
      if (scrollToTarget() || attempts >= maxAttempts) {
        clearInterval(interval);
      }
      attempts++;
    }, 100);
  }
});


// ---------- Form Tamper Detection begin ----------
document.addEventListener("DOMContentLoaded", function () {
  const errorSpan = document.getElementById("inquiries-error");
  let textarea = document.getElementsByName("inquiries")[0];
  let trustedValue = "";

  if (!textarea) return;

  // ---------- Sanitizer ----------
  function sanitizeInput() {
    if (!textarea) return;

    let text = textarea.value;

    // Cyrillic check
    if (/[\u0400-\u04FF]/.test(text)) {
      textarea.value = "";
      trustedValue = "";
      if (errorSpan) errorSpan.textContent = "Cyrillic characters are not allowed.";
      return;
    } else if (errorSpan) {
      errorSpan.textContent = "";
    }

    // Remove HTML/JS/URLs
    const unsafePatterns = [
      /<\/?[^>]+/g,
      /(?:javascript|vbscript|data):/gi,
      /on\w+\s*=\s*['"]?[^'" >]+/gi,
      /document\.\w+/gi,
      /window\.\w+/gi,
      /alert\s*\([^)]*\)/gi,
      /eval\s*\([^)]*\)/gi,
      /<\?(php)?[\s\S]*?\?>/gi,
      /https?:\/\/\S+/gi,
      /href\s*=\s*(['"])[\s\S]*?\1/gi,
      /href\s*=\s*[^\s>]+/gi
    ];
    unsafePatterns.forEach(pattern => text = text.replace(pattern, ""));

    // Cleanup extra spaces/newlines
    textarea.value = text.replace(/\s{2,}/g, " ").replace(/\n{3,}/g, "\n\n");

    trustedValue = textarea.value;
  }

  // ---------- Tamper Detection ----------
  function checkTamper() {
    if (!textarea) return;
    if (textarea.value !== trustedValue) {
      textarea.value = "";
      trustedValue = "";
      if (errorSpan) errorSpan.textContent = "Cyrillic characters are not allowed.";
      location.reload();
    }
  }

  // ---------- Attach events ----------
  function attachListeners(t) {
    if (!t) return;

    ["input", "paste", "change", "blur", "keyup", "beforeinput"].forEach(evt => {
      t.addEventListener(evt, () => {
        sanitizeInput();
        setTimeout(checkTamper, 0);
      });
    });

    // Override .value property to detect JS tampering
    try {
      const descriptor = Object.getOwnPropertyDescriptor(HTMLTextAreaElement.prototype, "value");
      if (descriptor && descriptor.configurable) {
        Object.defineProperty(t, "value", {
          get() { return descriptor.get.call(this); },
          set(val) {
            descriptor.set.call(this, val);
            sanitizeInput();
            checkTamper();
          }
        });
      }
    } catch (e) {}
  }

  attachListeners(textarea);
  sanitizeInput();

  // ---------- Polling ----------
  setInterval(checkTamper, 50);

  // ---------- Detect node replacement (Edit as HTML) ----------
  const observer = new MutationObserver(() => {
    const current = document.getElementsByName("inquiries")[0];
    if (current && current !== textarea) {
      textarea = current;
      attachListeners(textarea);
      sanitizeInput();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// ---------- Form Tamper Detection End ----------
